





























































































































































































import Vue from "vue";
import HttpClientFactory from "../../../../services/HttpClientFactory";
import { ValidationObserver } from "vee-validate";
import { TimeSelect, DatePicker, Select, Option } from "element-ui";
import HttpClient from "../../../../services/HttpClient";
import ApiReceiver from "../../../../types/receivers/api/ApiReceiver";
import ReceiverIndexResponse from "../../../../types/receivers/api/ReceiverIndexResponse";
import Invoice from "../../../../types/invoices/Invoice";
import InvoiceLine from "../../../../types/invoices/InvoiceLine";
import swal from "sweetalert2";
import moment from "moment";
import currency from "currency.js";
import Receiver from "../../../../types/receivers/Receiver";

interface ReceiverSelectorOption {
  value: number;
  label: string;
}

interface NexNumberApiResponse {
  nextNumber: string;
}

interface IsUniqueNumberApiResponse {
  isUnique: boolean;
}

export default Vue.extend({
  name: "create-invoices-form",
  components: {
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data() {
    return {
      httpClient: {} as HttpClient,
      invoice: {
        receiver: {} as Receiver,
        invoiceDateAt: null,
        invoiceNumber: "",
        dueDateAt: null,
        description: "",
        priceWithoutVatAndTaxes: currency(0),
        vat: currency(0),
        grandTotal: currency(0),
        lines: [] as InvoiceLine[],
      } as Invoice,
      receiverSelector: {
        selectedOption: null as ReceiverSelectorOption | null,
        options: [] as ReceiverSelectorOption[],
      },
    };
  },
  async created() {
    this.loadReceiversSelectorOptions();
    this.loadNextInvoiceNumber();
    this.invoice.invoiceDateAt = new Date(
      moment().startOf("day").toISOString()
    );
  },
  methods: {
    receiverLabel({ value, label }: ReceiverSelectorOption): string {
      return label;
    },
    async validate() {
      const isValid = await (
        this.$refs.form as InstanceType<typeof ValidationObserver>
      ).validate();
      if (isValid) {
        if (!(await this.isUniqueInvoiceNumber())) {
          try {
            const result = await swal.fire({
              title: this.$t(
                "invoices:create.repeated_number.question_invoice_number"
              ),
              text: this.$t(
                "invoices:create.repeated_number.text_repeat_invoice_number"
              ),
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: this.$t(
                "invoices:create.repeated_number.buttons.yes"
              ),
              cancelButtonText: this.$t(
                "invoices:create.repeated_number.buttons.no"
              ),
              customClass: {
                confirmButton: "btn btn-next btn-wd btn-primary",
                cancelButton: "btn btn-next btn-wd btn-danger",
              },
              buttonsStyling: false,
            });
            if (result.isDismissed) {
              return false;
            }
            if (result.isConfirmed) {
              this.$emit("on-validated", isValid);
              this.$emit("on-invoice-validated", this.invoice);
              return isValid;
            }
          } catch (e) {
            const error: any = {
              text: this.$t("invoices:error"),
              type: "error",
            };
            this.$notify(error);
          }
        }
        this.$emit("on-invoice-validated", this.invoice);
      }
      return isValid;
    },
    async loadReceiversSelectorOptions() {
      this.httpClient = HttpClientFactory.getInstance();
      try {
        const res: any = await this.httpClient.get(
          process.env.VUE_APP_BACKEND_ENDPOINT + "/receivers/v1/view"
        );
        const apiReceiver: ReceiverIndexResponse = res.data;

        this.receiverSelector.options = apiReceiver
          .filter((receiver) => !receiver.deletedAt)
          .map((receiverData: ApiReceiver) => {
            return {
              value: receiverData.id,
              label: receiverData.companyName,
            };
          });
      } catch (e) {
        const error: any = {
          text: this.$t("invoices:error"),
          type: "error",
        };
        this.$notify(error);
      }
    },
    async loadNextInvoiceNumber() {
      this.httpClient = HttpClientFactory.getInstance();
      try {
        const res: any = await this.httpClient.get(
          process.env.VUE_APP_BACKEND_ENDPOINT +
            "/invoice/v1/next-invoice-number"
        );
        const responseData: NexNumberApiResponse = res.data;
        this.invoice.invoiceNumber = responseData.nextNumber;
      } catch (e) {
        const error: any = {
          text: this.$t("invoices:error"),
          type: "error",
        };
        this.$notify(error);
      }
    },
    async isUniqueInvoiceNumber(): Promise<boolean> {
      this.httpClient = HttpClientFactory.getInstance();
      try {
        const res: any = await this.httpClient.post(
          process.env.VUE_APP_BACKEND_ENDPOINT +
            "/invoice/v1/is-unique-invoice-number",
          this.invoice
        );
        const responseData: IsUniqueNumberApiResponse = res.data;
        return responseData.isUnique;
      } catch (e) {
        const error: any = {
          text: this.$t("invoices:error"),
          type: "error",
        };
        this.$notify(error);
        return false;
      }
    },
    setReceiverId(option: ReceiverSelectorOption) {
      this.invoice.receiver.id = option.value;
    },
  },
});
